import { useRouter } from 'next/router';

export function usePage() {
  const router = useRouter();

  return router.pathname ?? 'Unmatched';
}
